const host = import.meta.env.REACT_APP_HOST || "localhost:7777" as string;
const schmema = host.startsWith("localhost") ? "http" : "https";
export const tenant = import.meta.env.REACT_APP_TENANT_NAME as string;
const proxy = import.meta.env.REACT_APP_PROXY_API_URL as string;
const signin_signup = import.meta.env.REACT_APP_SIGN_UP_SIGN_IN_POLICY as string;
const reset_password = import.meta.env.REACT_APP_PASSWORD_RESET_POLICY as string;
const clientID = import.meta.env.REACT_APP_CLIENT_ID_LANDING as string;
const proxy_landing = import.meta.env.REACT_APP_PROXY_API_LANDING_URL as string;
const domain_base = import.meta.env.REACT_APP_DOMAIN_API_BASE as string;



export const msalConfig = {
    auth: {
        clientId: clientID,
        authority: `https://${tenant}.b2clogin.com/${tenant}.onmicrosoft.com/${signin_signup}`,
        knownAuthorities: [`${tenant}.b2clogin.com`],
        redirectUri: `${schmema}://${host}/oauth-callback`,
        postLogoutRedirectUri: `${schmema}://${host}`,
        authorityMetadata: import.meta.env.REACT_APP_B2C_METADATA_PULLED as string || import.meta.env.REACT_APP_B2C_METADATA as string
    }
};


export const loginAdminRequest = {
    scopes: [`openid https://${tenant}.onmicrosoft.com/GlobalIAMAdminAPI/Access`]
};

export const loginLandingPageRequest = {
    scopes: [`openid https://${tenant}.onmicrosoft.com/LandingPageAPI/Read`]
};

export const forgotPasswordRequest = {
    authority: `https://${tenant}.b2clogin.com/${tenant}.onmicrosoft.com/${reset_password}`
};

export const adminConfig = {
    adminEndpoint: proxy
};

export const landingPageConfig = {
    landingEndpoint: proxy_landing
};

export const domainConfig = {
    domainBase: domain_base
};

export interface IdClaimsWithRoles {
    roles?: string[];
    mail?: string[];
}
